import { render, staticRenderFns } from "./informate-list.vue?vue&type=template&id=4ae92702&scoped=true&"
import script from "./informate-list.vue?vue&type=script&lang=js&"
export * from "./informate-list.vue?vue&type=script&lang=js&"
import style0 from "./informate-list.vue?vue&type=style&index=0&id=4ae92702&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae92702",
  null
  
)

export default component.exports